import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const TableLoading = ({ styles }) => (
  <div className={styles.Loading} data-testid="table-loading">
    <CircularProgress className={styles.LoadingIcon} />
  </div>
);

export default TableLoading;
